import { useAnswerMode } from '@/data/hook/question/answers/useAnswerMode';
import { QuizAnswerCreateDTO } from '@/models/Answer';
import QuizAnswerMedia from './QuizAnswerMedia';
import QuizAnswerText from './QuizAnswerText';

type QuizAnswerItemProps = {
  answer: QuizAnswerCreateDTO;
  initialEditing?: boolean;
  onUpdateText: (text: string) => void;
  onUpdateMedia: (file: File | string, altText?: string) => void;
  onToggleCorrect: () => void;
  onDelete: () => void;
  isLoading?: boolean;
};

export default function QuizAnswerItem({
  answer,
  initialEditing,
  onUpdateText,
  onUpdateMedia,
  onToggleCorrect,
  onDelete,
  isLoading = false,
}: QuizAnswerItemProps) {
  const {
    mode,
    isEditing,
    handleSwitchToMedia,
    handleSwitchToText,
    handleStartEdit,
    handleFinishEdit,
  } = useAnswerMode({
    mediaFile: answer.mediaFile,
    mediaLink: answer.mediaLink,
    initialEditing,
  });

  if (mode === 'media') {
    return (
      <QuizAnswerMedia
        answer={answer}
        isEditing={isEditing}
        onStartEdit={handleStartEdit}
        onFinishEdit={handleFinishEdit}
        onUpdateMedia={onUpdateMedia}
        onSwitchToText={handleSwitchToText}
        onToggleCorrect={onToggleCorrect}
        onDelete={onDelete}
        isLoading={isLoading}
      />
    );
  }

  return (
    <QuizAnswerText
      answer={answer}
      isEditing={isEditing}
      onStartEdit={handleStartEdit}
      onFinishEdit={handleFinishEdit}
      onUpdateText={onUpdateText}
      onSwitchToMedia={handleSwitchToMedia}
      onToggleCorrect={onToggleCorrect}
      onDelete={onDelete}
      isLoading={isLoading}
    />
  );
}
